import { create } from "zustand";
import type { PDA1091_R01ScanResultDto, AuditItem } from "./PDA1091_R01Dto";

interface State {
  loading: boolean;
  setLoading: (v: boolean) => void;

  warehouseCd: string;
  setWarehouseCd: (v: string) => void;
  warehouseNm: string;
  setWarehouseNm: (v: string) => void;

  scanValue: string;
  setScanValue: (v: string) => void;

  scannedItem: PDA1091_R01ScanResultDto | null;
  setScannedItem: (i: PDA1091_R01ScanResultDto | null) => void;

  actualStock: number | null;
  setActualStock: (q: number | null) => void;

  auditItems: AuditItem[];
  addAuditItem: (item: AuditItem) => void;
  removeAuditItem: (itemCd: string) => void;
  setAuditItems: (list: AuditItem[]) => void;
  clearAuditItems: () => void;

  reset: () => void;
  resetForm: () => void;
}

const usePDA1091_R01Store = create<State>((set) => ({
  loading: false,
  setLoading: (loading) => set({ loading }),

  warehouseCd: "",
  setWarehouseCd: (warehouseCd) => set({ warehouseCd }),
  warehouseNm: "",
  setWarehouseNm: (warehouseNm) => set({ warehouseNm }),

  scanValue: "",
  setScanValue: (scanValue) => set({ scanValue }),

  scannedItem: null,
  setScannedItem: (scannedItem) => set({ scannedItem }),

  actualStock: null,
  setActualStock: (actualStock) => set({ actualStock }),

  auditItems: [],
  addAuditItem: (item) => set((s) => ({ auditItems: [...s.auditItems, item] })),
  removeAuditItem: (itemCd) =>
    set((s) => ({ auditItems: s.auditItems.filter((i) => i.itemCd !== itemCd) })),
  setAuditItems: (auditItems) => set({ auditItems }),
  clearAuditItems: () => set({ auditItems: [] }),

  reset: () =>
    set({
      loading: false,
      scanValue: "",
      scannedItem: null,
      actualStock: null,
      auditItems: [],
      warehouseCd: "",
      warehouseNm: "",
    }),

  // warehouseCd, warehouseNm은 resetForm에서 유지 (검수 후에도 같은 창고 사용)
  resetForm: () =>
    set({ scanValue: "", scannedItem: null, actualStock: null }),
}));

export default usePDA1091_R01Store;